import { render, staticRenderFns } from "./SocialProfile.vue?vue&type=template&id=30d35cd6&scoped=true&"
import script from "./SocialProfile.vue?vue&type=script&lang=js&"
export * from "./SocialProfile.vue?vue&type=script&lang=js&"
import style0 from "./SocialProfile.vue?vue&type=style&index=0&id=30d35cd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d35cd6",
  null
  
)

export default component.exports